import e, { useRef as n, useEffect as r, useMemo as t, useState as o, useCallback as a } from "react";
import l from "prop-types";
import { css as i, cx as c } from "@leafygreen-ui/emotion";
import { palette as s, uiColors as d } from "@leafygreen-ui/palette";
import { getNodeTextContent as f, keyMap as u, isComponentType as p } from "@leafygreen-ui/lib";
import { validateAriaLabelProps as b } from "@leafygreen-ui/a11y";
import m from "@leafygreen-ui/portal";
import { useIdAllocator as g } from "@leafygreen-ui/hooks";
import y from "@leafygreen-ui/box";
import { useUsingKeyboardContext as h } from "@leafygreen-ui/leafygreen-provider";
import { fontFamilies as v } from "@leafygreen-ui/tokens";
import { jsx as w } from "@emotion/react";

function k(e, n) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, t);
  }

  return r;
}

function O(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = null != arguments[n] ? arguments[n] : {};
    n % 2 ? k(Object(r), !0).forEach(function (n) {
      x(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : k(Object(r)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }

  return e;
}

function x(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

function j() {
  return j = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
      }
    }

    return e;
  }, j.apply(this, arguments);
}

function N(e, n) {
  if (null == e) return {};

  var r,
      t,
      o = function (e, n) {
    if (null == e) return {};
    var r,
        t,
        o = {},
        a = Object.keys(e);

    for (t = 0; t < a.length; t++) {
      r = a[t], n.indexOf(r) >= 0 || (o[r] = e[r]);
    }

    return o;
  }(e, n);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (t = 0; t < a.length; t++) {
      r = a[t], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }

  return o;
}

function C(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}

function P(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == r) return;
    var t,
        o,
        a = [],
        l = !0,
        i = !1;

    try {
      for (r = r.call(e); !(l = (t = r.next()).done) && (a.push(t.value), !n || a.length !== n); l = !0) {
        ;
      }
    } catch (e) {
      i = !0, o = e;
    } finally {
      try {
        l || null == r.return || r.return();
      } finally {
        if (i) throw o;
      }
    }

    return a;
  }(e, n) || function (e, n) {
    if (!e) return;
    if ("string" == typeof e) return S(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(e);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return S(e, n);
  }(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function S(e, n) {
  (null == n || n > e.length) && (n = e.length);

  for (var r = 0, t = new Array(n); r < n; r++) {
    t[r] = e[r];
  }

  return t;
}

var T,
    D,
    R,
    A,
    E,
    I,
    X,
    K,
    M,
    z,
    L,
    F,
    U = ["selected", "disabled", "children", "className", "darkMode", "parentRef"],
    W = {
  light: {
    base: i(T || (T = C(["\n      color: ", ";\n      font-weight: 500;\n      font-family: ", ";\n      font-size: 13px;\n    "])), s.gray.dark1, v.default),
    hover: i(D || (D = C(["\n      &:hover {\n        cursor: pointer;\n        color: ", ";\n        &:after {\n          background-color: ", ";\n        }\n      }\n    "])), s.gray.dark3, s.gray.light2),
    focus: i(R || (R = C(["\n      &:focus {\n        color: ", ";\n        font-weight: 700;\n\n        &:after {\n          background-color: ", ";\n        }\n      }\n    "])), s.blue.base, s.blue.light1),
    selected: i(A || (A = C(["\n      color: ", ";\n      font-weight: 700;\n\n      &:after {\n        transform: scaleX(1);\n        background-color: ", ";\n      }\n\n      &:hover {\n        color: ", ";\n\n        &:after {\n          transform: scaleX(1);\n          background-color: ", ";\n        }\n      }\n    "])), s.green.dark2, s.green.dark1, s.green.dark2, s.green.dark1),
    disabled: i(E || (E = C(["\n      cursor: not-allowed;\n      color: ", ";\n    "])), s.gray.light1)
  },
  dark: {
    base: i(I || (I = C(["\n      color: ", ";\n      font-weight: 600;\n      font-family: ", ";\n      font-size: 16px;\n    "])), d.gray.light1, v.legacy),
    hover: i(X || (X = C(["\n      &:hover {\n        cursor: pointer;\n\n        &:not(:focus) {\n          color: ", ";\n\n          &:after {\n            background-color: ", ";\n          }\n        }\n      }\n    "])), d.white, d.gray.dark1),
    focus: i(K || (K = C(["\n      &:focus {\n        color: ", ";\n\n        &:after {\n          background-color: ", ";\n        }\n      }\n    "])), d.blue.light1, d.focus),
    selected: i(M || (M = C(["\n      color: ", ";\n\n      &:after {\n        transform: scaleX(1);\n        background-color: ", ";\n      }\n\n      &:hover {\n        color: ", ";\n        font-weight: 700;\n\n        &:after {\n          transform: scaleX(1);\n          background-color: ", ";\n        }\n      }\n    "])), d.green.light2, d.green.base, d.green.light2, d.green.base),
    disabled: i(z || (z = C(["\n      cursor: not-allowed;\n      color: ", ";\n    "])), d.gray.dark1)
  }
},
    $ = i(L || (L = C(["\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  max-width: 300px;\n  padding: 12px 16px;\n  background-color: transparent;\n  border: 0px;\n  text-decoration: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: 150ms color ease-in-out;\n\n  &:focus {\n    outline: none;\n  }\n\n  // We create a pseudo element that's the width of the bolded text\n  // This way there's no layout shift on hover when the text is bolded.\n  &:before {\n    content: attr(data-text);\n    height: 0;\n    font-weight: 700;\n    visibility: hidden;\n    overflow: hidden;\n    user-select: none;\n    pointer-events: none;\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 4px;\n    border-radius: 4px 4px 0 0;\n    transition: all 150ms ease-in-out;\n    background-color: transparent;\n    transform: scaleX(0.8);\n  }\n\n  &:hover:after {\n    transform: scaleX(0.95);\n  }\n\n  &:active:after {\n    &:after {\n      transform: scaleX(1);\n    }\n  }\n\n  > * {\n    vertical-align: middle;\n  }\n"]))),
    q = i(F || (F = C(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"]))),
    B = function B(e) {
  var t,
      o,
      a = e.selected,
      l = void 0 !== a && a,
      i = e.disabled,
      s = void 0 !== i && i,
      d = e.children,
      u = e.className,
      p = e.darkMode,
      b = e.parentRef,
      m = N(e, U),
      g = h().usingKeyboard,
      v = n(null),
      k = p ? ee.Dark : ee.Light;
  r(function () {
    var e,
        n = Array.from(null !== (e = null == b ? void 0 : b.children) && void 0 !== e ? e : []),
        r = document.activeElement;
    r && -1 !== n.indexOf(r) && !s && l && v.current && v.current.focus();
  }, [b, s, l, v]);
  var C = f(m.name),
      P = O(O({}, m), {}, (o = {
    className: c($, W[k].base, (t = {}, x(t, W[k].selected, l), x(t, W[k].focus, g), x(t, W[k].hover, !s && !l), x(t, W[k].disabled, s), t), u),
    role: "tab",
    tabIndex: l ? 0 : -1
  }, x(o, "aria-selected", l), x(o, "name", C), x(o, "data-text", C), o));
  return "string" == typeof m.href ? w(y, j({
    as: "a",
    ref: v
  }, P), w("div", {
    className: q
  }, d)) : w(y, j({
    as: "button",
    ref: v
  }, P), w("div", {
    className: q
  }, d));
};

B.displayName = "TabTitle";
var G = ["child", "selected", "tabRef", "panelRef"],
    H = e.memo(function (n) {
  var r = n.child,
      o = n.selected,
      a = n.tabRef,
      l = n.panelRef,
      i = N(n, G),
      c = r.props,
      s = c.id,
      d = c.name,
      f = g({
    prefix: "tab-panel"
  }),
      u = g({
    prefix: "tab",
    id: s
  }),
      p = w(B, j({}, i, {
    selected: o,
    id: u,
    "aria-controls": f
  }), d),
      b = t(function () {
    return e.cloneElement(r, x({
      id: f,
      selected: o
    }, "aria-labelledby", u));
  }, [r, f, o, u]);
  return w(e.Fragment, null, w(m, {
    container: a
  }, p), w(m, {
    container: l
  }, b));
});
H.displayName = "InternalTab";
var J,
    Q,
    V,
    Y,
    Z = ["children", "setSelected", "selected", "className", "darkMode", "as", "aria-labelledby", "aria-label"],
    _ = ["disabled", "onClick", "onKeyDown", "className"],
    ee = {
  Dark: "dark",
  Light: "light"
},
    ne = (x(V = {}, ee.Light, {
  underlineColor: i(J || (J = C(["\n      border-bottom: 1px solid ", ";\n    "])), s.gray.light2)
}), x(V, ee.Dark, {
  underlineColor: i(Q || (Q = C(["\n      border-bottom: 1px solid ", ";\n    "])), d.gray.dark2)
}), V),
    re = i(Y || (Y = C(["\n  list-style: none;\n  padding: 0;\n  display: flex;\n  width: 100%;\n  overflow-x: auto;\n\n  /* Remove scrollbar */\n\n  /* Chrome, Edge, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  -ms-overflow-style: none; /* IE */\n  scrollbar-width: none; /* Firefox */\n"])));

function te(n) {
  var r;
  b(n, "Tabs");
  var l = n.children,
      i = n.setSelected,
      s = n.selected,
      d = n.className,
      f = n.darkMode,
      m = void 0 !== f && f,
      g = n.as,
      y = void 0 === g ? "button" : g,
      h = n["aria-labelledby"],
      v = n["aria-label"],
      k = N(n, Z),
      C = m ? ee.Dark : ee.Light,
      S = P(o(null), 2),
      T = S[0],
      D = S[1],
      R = P(o(null), 2),
      A = R[0],
      E = R[1],
      I = (x(r = {}, "aria-label", v), x(r, "aria-labelledby", h), r),
      X = t(function () {
    return e.Children.toArray(l);
  }, [l]),
      K = "number" == typeof s,
      M = P(o(X.findIndex(function (e) {
    return e.props.default || 0;
  })), 2),
      z = M[0],
      L = M[1],
      F = K ? s : z,
      U = K ? i : L,
      W = a(function (e, n) {
    null == U || U(n);
  }, [U]),
      $ = a(function () {
    var e = X.filter(function (e) {
      return !e.props.disabled;
    }).map(function (e) {
      return X.indexOf(e);
    });
    return [e, e.indexOf(F)];
  }, [X, F]),
      q = a(function (e) {
    if (!e.metaKey && !e.ctrlKey) if (e.keyCode === u.ArrowRight) {
      var n = P($(), 2),
          r = n[0],
          t = n[1];
      null == U || U(r[(t + 1) % r.length]);
    } else if (e.keyCode === u.ArrowLeft) {
      var o = P($(), 2),
          a = o[0],
          l = o[1];
      null == U || U(a[(l - 1 + a.length) % a.length]);
    }
  }, [$, U]),
      B = e.Children.map(l, function (e, n) {
    if (!p(e, "Tab")) return e;
    var r = n === F,
        t = e.props,
        o = t.disabled,
        a = t.onClick,
        l = t.onKeyDown,
        i = t.className,
        c = N(t, _),
        s = O({
      as: y,
      disabled: o,
      darkMode: m,
      parentRef: T,
      className: i,
      onKeyDown: function onKeyDown(e) {
        null == l || l(e), q(e);
      },
      onClick: o ? void 0 : function (e) {
        null == a || a(e), W(e, n);
      }
    }, c);
    return w(H, j({
      child: e,
      selected: r,
      tabRef: T,
      panelRef: A
    }, s));
  });
  return w("div", j({}, k, {
    className: d
  }), B, w("div", j({
    className: c(re, ne[C].underlineColor),
    role: "tablist",
    ref: D,
    "aria-orientation": "horizontal"
  }, I)), w("div", {
    ref: E
  }));
}

te.displayName = "Tabs", te.propTypes = {
  children: l.node,
  setSelected: l.func,
  selected: l.number,
  className: l.string,
  as: l.oneOfType([l.string, l.func])
};
var oe = ["selected", "children"];

function ae(e) {
  var n = e.selected,
      r = e.children,
      t = N(e, oe);
  return delete t.default, delete t.name, delete t.onClick, delete t.href, w("div", j({}, t, {
    role: "tabpanel"
  }), n ? r : null);
}

ae.displayName = "Tab", ae.propTypes = {
  selected: l.bool,
  children: l.node,
  name: l.oneOfType([l.string, l.node]),
  content: l.node,
  disabled: l.bool,
  ariaControl: l.string
};
export { ae as Tab, te as Tabs };